import { CheckCircle } from 'lucide-react';
import { Plan, PlanType } from '../../contexts/SubscriptionContext';

interface PlanCardProps {
  plan: Plan;
  currentPlanId: PlanType;
  onSelectPlan: (planId: PlanType) => void;
  className?: string;
}

const PlanCard: React.FC<PlanCardProps> = ({
  plan,
  currentPlanId,
  onSelectPlan,
  className = '',
}) => {
  const isCurrentPlan = currentPlanId === plan.id;

  return (
    <div 
      className={`relative bg-white border rounded-lg shadow-sm overflow-hidden ${
        isCurrentPlan 
          ? 'border-primary-500 ring-2 ring-primary-500' 
          : 'border-gray-200 hover:border-primary-300'
      } ${className}`}
    >
      {isCurrentPlan && (
        <div className="absolute top-0 inset-x-0 px-4 py-1 bg-primary-500 text-white text-center text-sm font-medium">
          Current Plan
        </div>
      )}

      <div className={`p-6 ${isCurrentPlan ? 'pt-12' : ''}`}>
        <h3 className="text-lg font-medium text-gray-900">{plan.name}</h3>
        
        <div className="mt-4 flex items-baseline">
          <span className="text-3xl font-bold text-gray-900">${plan.price}</span>
          <span className="ml-1 text-sm font-medium text-gray-500">/{plan.billingPeriod}</span>
        </div>
        
        <p className="mt-1 text-sm text-gray-500">
          {plan.id === 'free' 
            ? 'Basic monitoring for personal use' 
            : plan.id === 'standard'
              ? 'Perfect for small businesses'
              : 'For organizations with many domains'
          }
        </p>

        <ul className="mt-6 space-y-3">
          {plan.features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <CheckCircle className="h-5 w-5 text-accent-500 flex-shrink-0 mr-2" />
              <span className="text-sm text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>

        <div className="mt-8">
          <button
            onClick={() => onSelectPlan(plan.id as PlanType)}
            disabled={isCurrentPlan}
            className={`w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 ${
              isCurrentPlan
                ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
                : 'bg-primary-500 text-white hover:bg-primary-600'
            }`}
          >
            {isCurrentPlan ? 'Current Plan' : 'Select Plan'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;